import { config, helpers, React, ts, useLocation, useSelector } from '_core';

const useWorkspaceMetadataBackgroundSave = () => {
  const { pathname } = useLocation();

  const currentWorkspaceId = useSelector((state) => state.ui.currentWorkspaceId);
  const currentTab = useSelector((state) => state.ui.currentTab);
  const authenticated = useSelector((state) => state.auth.authenticated);

  const getWorkspaceContext = React.useCallback(
    (type: ts.enums.RESOURCES_TYPES_ENUM | undefined): 'research' | 'production' => {
      if (!type) return currentTab === 'production' ? 'production' : 'research';
      if (
        config.productionResources.includes(
          // We know that there is an overlap between RESOURCES_TYPES_ENUM and UI_RESOURCE_TYPE_ENUM
          // so we can cast it to UI_RESOURCE_TYPE_ENUM
          type as unknown as ts.enums.UI_RESOURCE_TYPE_ENUM
        )
      ) {
        return 'production';
      }
      return currentTab === 'production' ? 'production' : 'research';
    },
    [currentTab]
  );

  const [itemType, itemId] = React.useMemo(() => {
    const split = pathname.split('/');
    const localItemType = split?.[1] ? (helpers.pluralize.singular(split[1]) as ts.enums.RESOURCES_TYPES_ENUM) : null;
    const localItemId = split?.[2] ? parseInt(split?.[2]) * 1 : null;

    if (localItemType && Object.values(ts.enums.RESOURCES_TYPES_ENUM).includes(localItemType)) {
      return [localItemType, localItemId] as const;
    }
    return [null, null] as const;
  }, [pathname]);

  React.useEffect(() => {
    if (!authenticated) return;
    if (!currentWorkspaceId) return;
    if (!itemType || !itemId) return;

    const wsContext = getWorkspaceContext(itemType);
    const item = { itemId, itemType };

    helpers.workspaceMetadata.updateOnNavigation(currentWorkspaceId, item, wsContext);
  }, [itemType, itemId, currentWorkspaceId, getWorkspaceContext, authenticated]);
};

export default useWorkspaceMetadataBackgroundSave;
